import Abstract from './class.Abstract';
import AJAX from './class.AJAX';
import Input from './class.Input';
import { qs } from '../dom-helpers';

class Minicart extends Abstract {
  constructor() {
    super();

    if (!qs('.mini-cart')) return;

    this.minicart = qs('.mini-cart');
    this.cartBtnWrapper = qs('.main-header__actions-item');
    this.minicartCloseBtn = qs('.mini-cart .mini-cart__close-btn');
    this.transparentHeader = qs('.main-header--fixed');
    this.updateTimeout = null;
    this.productIds = [];
    this.productQuantity = [];

    this._initEvents();
  }

  _initEvents() {
    this._openOnCartButtonClick();
    this._openOnProductAdding();
    this._closeOnOverlayClicking();
    this._closeOnCloseButtonClicking();
    this._initQuantityButtons();
    this._initQuantityInputs();
    this._leaveTransparentHeaderBackgroundOnScroll();
    this._updateMiniCart();
  }

  _openOnCartButtonClick() {
    this.cartBtnWrapper.addEventListener('click', (e) => {
      e.preventDefault();

      const el = e.target;

      if (el.closest('.main-header__cart-link')) {
        if (this.isOpened()) {
          this.close();
        } else {
          this.open();
        }
      }
    });
  }

  _openOnProductAdding() {
    jQuery(document.body).on('added_to_cart', () => {
      // Client doesn't want minicart to be opened on cart page
      if (this.isCart) {
        return window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }

      // Inputs don't have proper width in some edge cases
      new Input().recalculateQuantityInputsWidth();

      // We don't need minicart on mobile and tablet screens
      if (true /*window.matchMedia('screen and (min-width: 1280px)').matches*/) {
        this.open();
      }
    });
  }

  _closeOnOverlayClicking() {
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('overlay--minicart')) {
        this.close();
      }
    });
  }

  _closeOnCloseButtonClicking() {
    if (this.minicartCloseBtn) {
      this.minicartCloseBtn.addEventListener('click', () => this.close());
    }
  }

  _initQuantityButtons() {
    this.minicart.addEventListener('click', (e) => {
      const node = e.target;

      if (!node.classList.contains('product__quantity-btn')) return;
      e.preventDefault();

      const buttonType = node.classList.contains('mini-cart__btn-plus') ? 'inc' : 'dec';
      const prodId = node.closest('.search-result').dataset.id;
      let newValue = 0;
      let input = null;

      if (buttonType === 'inc') {
        newValue = parseInt(node.previousElementSibling.children[1].value, 10) + 1;
        input = node.previousElementSibling.children[1];
      } else {
        newValue = parseInt(node.nextElementSibling.children[1].value, 10) - 1;
        if (newValue <= 0) newValue = 0;
        input = node.nextElementSibling.children[1];
      }

      input.value = newValue;

      if (this.productIds.length === 0 || this.isProductInArray(prodId) === -1) {
        this.productIds.push(prodId);
        this.productQuantity.push(newValue);
      } else {
        this.productQuantity[this.isProductInArray(prodId)] = newValue;
      }

      new Input().updateInputWidth(input);

      clearTimeout(this.updateTimeout); 
      this.updateTimeout = setTimeout(() => this.updateProductQuantity(), 1200);
    });
  }

  _initQuantityInputs() {
    this.minicart.addEventListener('click', (e) => {
      const node = e.target;

      if (!node.classList.contains('qty')) return;

      node.addEventListener('change', () => {

        const prodId = node.closest('.search-result').dataset.id;

        if (this.productIds.length === 0 || this.isProductInArray(prodId) === -1) {
          this.productIds.push(prodId);
          this.productQuantity.push(node.value);
        } else {
          this.productQuantity[this.isProductInArray(prodId)] = node.value;
        }
        this.updateProductQuantity();
        //clearTimeout(this.updateTimeout);
        //this.updateTimeout = setTimeout(() => this.updateProductQuantity(), 1200);
      });
    });
  }

  isProductInArray(prodId) {
    let switcher = -1;

    if (this.productIds) {
      const arrLength = this.productIds.length;

      for (let i = 0; i <= arrLength; i += 1) {
        if (prodId === this.productIds[i]) {
          switcher = i;
          break;
        }
      }
    }

    return switcher;
  }

  static _removeOverlay() {
    const el = qs('.overlay--minicart');
    if (el) el.remove();
  }

  static _createOverlay() {
    const el = document.createElement('div');
    el.className = 'overlay overlay--minicart';
    document.body.appendChild(el);
  }

  static isOverlayExists() {
    return !!qs('.overlay--minicart');
  }

  isOpened() {
    return this.minicart.classList.contains('mini-cart--opened');
  }

  close() {
    const cartIcon = qs('.main-header__cart-link');
    Minicart._removeOverlay();

    if (cartIcon) {
      cartIcon.classList.remove(super.getHTMLClasses().minicartIconActive);
    }

    if (this.transparentHeader) {
      this.transparentHeader.classList.remove('main-header--white');
    }

    // Abstract.refreshFragments();

    this.minicart.classList.remove('mini-cart--opened');
    jQuery(`.${super.getHTMLClasses().minicart}`).fadeOut();
  }

  open() {
    if (this.isOpened()) return;

    const cartIcon = qs('.main-header__cart-link');

    if (!Minicart.isOverlayExists()) {
      Minicart._createOverlay();
    }

    if (cartIcon) {
      cartIcon.classList.add(super.getHTMLClasses().minicartIconActive);
    }

    if (this.transparentHeader) {
      this.transparentHeader.classList.add('main-header--white');
    }

    this.minicart.classList.add('mini-cart--opened');
    jQuery(`.${super.getHTMLClasses().minicart}`).fadeIn();
  }

  updateProductQuantity() {
    const _this = this;

    console.log('this.productIds - ', this.productIds);
    console.log('this.productQuantity - ', this.productQuantity);

    AJAX.post({
      action: 'mst_somi_update_cart_item_qty',
      data: {
        product_ids: this.productIds,
        new_quantities: this.productQuantity,
      },
      beforeSend() {
        jQuery(_this.minicart).block(_this.getBlockSettings());
      },
      success() {
        if (_this.isCheckout) {
          location.reload();
        } else {
          Abstract.refreshFragments();
        }
        this.productIds = [];
        this.productQuantity = [];
      },
    });
  }

  _updateMiniCart() {
    jQuery(document.body).on('wc_fragments_refreshed', () => {
      setTimeout(() => jQuery(this.minicart).unblock(), 1000);
    });
  }

  _leaveTransparentHeaderBackgroundOnScroll() {
    window.addEventListener('scroll', () => {
      if (this.isOpened() && this.transparentHeader) {
        this.transparentHeader.classList.add('main-header--white');
      }
    });
  }
}

export default Minicart;
